import { createContext } from "react";

import type { BoardContextValue } from "src/pages/projects/board-context";

/**
 * Lives apart from board-context.tsx, which is in an import cycle through
 * src/router, so a hot update there keeps the context mounted providers hold.
 */
export const BoardContext = createContext<BoardContextValue | undefined>(
  undefined,
);
